import * as React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/AuthProvider";

export interface ProtectedRouteProps {
  element: React.ReactNode;
  requiredRole?: 'ADMIN' | 'USER';
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  element,
  requiredRole,
}) => {
  const auth = useAuth();
  const location = useLocation();

  if (auth.isLoading) {
    return null; // or a loading spinner
  }

  if (!auth.isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredRole === 'ADMIN' && !auth.isAdmin) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <>{element}</>;
};

export default ProtectedRoute;
